import React, { useEffect, useRef, useState } from "react";
import "../styles/HeroSection.css";
import Navbar from "./Navbar";
import { ArrowRight } from "lucide-react";

export default function HeroSection({ onContactClick, onScrollToCarousel }) {
  const heroRef = useRef(null);
  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowNavbar(entry.intersectionRatio > 0.5); 
      },
      { threshold: Array.from({ length: 101 }, (_, i) => i / 100) }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
    };
  }, []);

  return (
    <div
      ref={heroRef}
      className="relative hero-section"
      style={{ backgroundImage: "url('/images/hero.png')" }}
    >
      {showNavbar && <Navbar onContactClick={onContactClick} />}

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Texte Hero */}
      <section className="relative max-w-4xl mx-auto px-6 text-center text-white z-10 pt-40">
        <h1 className="text-4xl md:text-5xl font-bold leading-tight">
          Simulez votre consommation <br />
          d'énergie facilement avec <br />
          <span className="text-teal-300">Greenline Technologies</span>
        </h1>
        <p className="mt-6 text-lg max-w-2xl mx-auto">
          Obtenez un aperçu précis de votre consommation d'énergie et découvrez
          comment réduire vos factures tout en adoptant des solutions durables.
        </p>
        <div className="mt-8">
          <button className="hero-btn" onClick={onScrollToCarousel}>
            <span>Essayer le simulateur</span>
            <ArrowRight className="hero-btn-icon mt-1" size={20} />
          </button>
        </div>
      </section>
    </div>
  );
}
